import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant17PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1823 819",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.9443 666.33C118.265 535.377 179.751 409.2 254.016 290.379C320.059 184.721 405.808 80.0969 544.776 71.0627C593.125 67.9222 646.031 80.9573 675.433 117.997C701.395 150.736 704.12 195.993 695.094 236.259C686.113 276.569 666.854 313.91 652.287 352.671C632.715 404.683 623.689 466.459 651.884 517.395C677.265 563.297 731.422 590.4 785.312 593.239C839.246 596.079 892.465 577.322 938.177 549.66C998.098 513.351 1046.58 463.448 1105.21 425.59C1234.88 341.787 1403.34 345.96 1538.33 419.352C1661.53 486.335 1747.68 612.899 1762.29 748.369",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant17PathwayIllustration as default };
